/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkSynchronizedTaskDataDto } from '../models/work-synchronized-task-data-dto';
import { WorkTenantTaskLink } from '../models/work-tenant-task-link';

@Injectable({ providedIn: 'root' })
export class WorkTenantsTaskLinksV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `taskLinksV2ControllerFindByProjectLink()` */
  static readonly TaskLinksV2ControllerFindByProjectLinkPath = '/v2/tenants/task-links/project-link/{projectLinkId}';

  /**
   * Required permissions: tenants:read, projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskLinksV2ControllerFindByProjectLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskLinksV2ControllerFindByProjectLink$Response(
    params: {
      projectLinkId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskLink>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskLinksV2Service.TaskLinksV2ControllerFindByProjectLinkPath, 'get');
    if (params) {
      rb.path('projectLinkId', params.projectLinkId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskLink>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskLinksV2ControllerFindByProjectLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskLinksV2ControllerFindByProjectLink(
    params: {
      projectLinkId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskLink>> {
    return this.taskLinksV2ControllerFindByProjectLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskLink>>): Array<WorkTenantTaskLink> => r.body)
    );
  }

  /** Path part for operation `taskLinksV2ControllerFindByLocalTask()` */
  static readonly TaskLinksV2ControllerFindByLocalTaskPath = '/v2/tenants/task-links/task/{taskId}';

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskLinksV2ControllerFindByLocalTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskLinksV2ControllerFindByLocalTask$Response(
    params: {
      taskId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskLink>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskLinksV2Service.TaskLinksV2ControllerFindByLocalTaskPath, 'get');
    if (params) {
      rb.path('taskId', params.taskId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskLink>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskLinksV2ControllerFindByLocalTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskLinksV2ControllerFindByLocalTask(
    params: {
      taskId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskLink>> {
    return this.taskLinksV2ControllerFindByLocalTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskLink>>): Array<WorkTenantTaskLink> => r.body)
    );
  }

  /** Path part for operation `taskLinksV2ControllerFindAllWithExternalData()` */
  static readonly TaskLinksV2ControllerFindAllWithExternalDataPath = '/v2/tenants/task-links/with-external-data';

  /**
   * Required permissions: tenants:read, projects:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskLinksV2ControllerFindAllWithExternalData()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskLinksV2ControllerFindAllWithExternalData$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkSynchronizedTaskDataDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskLinksV2Service.TaskLinksV2ControllerFindAllWithExternalDataPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkSynchronizedTaskDataDto>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, projects:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskLinksV2ControllerFindAllWithExternalData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskLinksV2ControllerFindAllWithExternalData(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkSynchronizedTaskDataDto>> {
    return this.taskLinksV2ControllerFindAllWithExternalData$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkSynchronizedTaskDataDto>>): Array<WorkSynchronizedTaskDataDto> => r.body)
    );
  }

  /** Path part for operation `taskLinksV2ControllerFindWithMissingTeamAssignment()` */
  static readonly TaskLinksV2ControllerFindWithMissingTeamAssignmentPath = '/v2/tenants/task-links/missing-team-assignment';

  /**
   * Required permissions: tenants:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskLinksV2ControllerFindWithMissingTeamAssignment()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskLinksV2ControllerFindWithMissingTeamAssignment$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskLink>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskLinksV2Service.TaskLinksV2ControllerFindWithMissingTeamAssignmentPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskLink>>;
      })
    );
  }

  /**
   * Required permissions: tenants:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskLinksV2ControllerFindWithMissingTeamAssignment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskLinksV2ControllerFindWithMissingTeamAssignment(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskLink>> {
    return this.taskLinksV2ControllerFindWithMissingTeamAssignment$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskLink>>): Array<WorkTenantTaskLink> => r.body)
    );
  }

  /** Path part for operation `taskLinksV2ControllerFindOne()` */
  static readonly TaskLinksV2ControllerFindOnePath = '/v2/tenants/task-links/{id}';

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskLinksV2ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskLinksV2ControllerFindOne$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantTaskLink>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskLinksV2Service.TaskLinksV2ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantTaskLink>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskLinksV2ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskLinksV2ControllerFindOne(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTenantTaskLink> {
    return this.taskLinksV2ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantTaskLink>): WorkTenantTaskLink => r.body)
    );
  }

  /** Path part for operation `taskLinksV2ControllerGetExternalData()` */
  static readonly TaskLinksV2ControllerGetExternalDataPath = '/v2/tenants/task-links/{id}/external-data';

  /**
   * Required permissions: tenants:read, projects:read, tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskLinksV2ControllerGetExternalData()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskLinksV2ControllerGetExternalData$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsTaskLinksV2Service.TaskLinksV2ControllerGetExternalDataPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: tenants:read, projects:read, tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskLinksV2ControllerGetExternalData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskLinksV2ControllerGetExternalData(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.taskLinksV2ControllerGetExternalData$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
